let userName = '';
let clientLogoUrl = '';

export const setUserName = (name) => {
  userName = name;
};

export const getUserName = () => userName;

export const setClientLogoUrl = (url) => {
  clientLogoUrl = url;
};

export const getClientLogoUrl = () => clientLogoUrl;

export const emptyElement = (node) => {
  let { firstChild } = node;
  while (firstChild) {
    node.removeChild(firstChild);
    ({ firstChild } = node);
  }
};

export const getFirstElementChild = (node) => {
  const childNodes = Array.prototype.slice.call(node.childNodes);
  for (let index = 0; index < childNodes.length; index += 1) {
    if (childNodes[index].nodeType === 1) {
      // 1 means its an element node
      return childNodes[index];
    }
  }
  return null;
};

export const simplifyWhiteSpace = (str) =>
  str.replace(/(?:\r\n|\r|\n)/g, '').replace(/\s+/g, '');

export const isBoolean = (x) =>
  Object.prototype.toString.call(x).toLowerCase() === '[object boolean]';

export const isObject = (obj) =>
  Object.prototype.toString.call(obj).toLowerCase() === '[object object]';

export const removeAllHtml = (html, allowLinks) => {
  const tmp = document.createElement('DIV');
  let r = '';
  if (tmp) {
    tmp.innerHTML = html;
    r = tmp.textContent;
    r = r
      ? r
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/javascript:/g, '')
        .replace(/<img/g, '')
        .replace(/<style/g, '')
        .replace(/<script/g, '')
      : '';
    // Only trim if newlines are the only things in the text areas.
    if (r.trim() === '') {
      r = r.trim();
    }
    if (allowLinks) {
      // This is a bad idea, but eCards must allow href's and a tags, we try and safely do it..
      r = r
        .replace('&lt;a href="', '<a href="')
        .replace(
          'target="_blank"&gt;',
          'target="_blank" rel="noopener noreferrer">',
        )
        .replace('&lt;/a&gt;', '</a>');
    }
  }
  return r;
};

export const customizeNames = (recipients) => {
  if (recipients.length === 1) return recipients[0].fullName;
  if (recipients.length === 2) { return `${recipients[0].fullName} and ${recipients[1].fullName}`; }
  return `${recipients[0].fullName} and ${recipients.length - 1} others`;
};
export const getLastElementChild = (node) => {
  const childNodes = Array.prototype.slice.call(node.childNodes);
  for (let index = childNodes.length - 1; index >= 0; index -= 1) {
    if (childNodes[index].nodeType === 1) {
      // 1 means its an element node
      return childNodes[index];
    }
  }
  return null;
};

export const hexToRgb = (clientColors = {}) => {
  const { primary = '' } = clientColors;
  if (primary) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(primary);
    if (result) {
      const obj = {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      };
      return `rgba(${obj.r}, ${obj.g}, ${obj.b}, 0.1)`;
    }
  }
  return '';
};

export const upperCase = (text) => {
  if (text) {
    return text.toUpperCase();
  }
  return '';
};

export const getNameInitials = (name, isCCApp) => {
  let result = '';
  if (name) {
    const value = name.split(' ');
    const firstName = value[0] ? value[0] : '';
    const lastName = value[1] ? value[1] : '';
    result = upperCase(firstName[0]);
    if (!isCCApp) {
      result = `${result}${upperCase(lastName[0])}`;
    }
  }
  return result;
};

export const imageExists = async (url) => {
  let isImageExist = false;
  const image = new Image();
  const imageLoaded = new Promise((resolve) => {
    image.src = url;
    image.onload = () => {
      resolve(true);
    };
    image.onerror = () => {
      resolve(false);
    };
  });

  isImageExist = await imageLoaded;
  return isImageExist;
};

export const isArray = (arr) => Array.isArray(arr);
